import { render, staticRenderFns } from "./ReferencesTable.vue?vue&type=template&id=6a942b52&"
import script from "./ReferencesTable.vue?vue&type=script&lang=js&"
export * from "./ReferencesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports